// extracted by mini-css-extract-plugin
export default {"title":"restaurants_title__KEAff","cards":"restaurants_cards__wptTE"};